import React from 'react';
import MoviesTable from './compnents/movies-table/movies-table';

const Movies: React.FC = () => {
  return (
    <div className="w-full h-full">
      <MoviesTable />
    </div>
  );
};

export default Movies;
